<template>
  <div class="field">
    <label class="label">Restrict whatsapp date</label>
    <div class="is-flex is-align-items-center">
      <div class="control is-flex-grow-1 mr-5">
        <input
          class="input"
          type="date"
          v-model="formattedValue"
          @focusout="handleChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ApplicantRestrictWhatsappDate',
  props: {
    value: {
      type: [String, Number],
      validator: prop => typeof prop === 'string' || typeof prop === 'number' || prop === null
    },
    applicantId: {
      type: Number,
      required: true
    }
  },
  computed: {
    formattedValue: {
      get () {
        if (!this.value) return ''
        const date = new Date(this.value)
        if (isNaN(date)) return ''
        // Extract the date part in "YYYY-MM-DD" format
        return date.toISOString().split('T')[0]
      },
      set (newValue) {
        // Convert the date back to ISO format before emitting
        const isoDate = new Date(newValue).toISOString()
        this.$emit('input', isoDate)
      }
    }
  },
  methods: {
    async handleChange () {
      try {
        await this.$network_utils.updateApplicant({ applicant_id: this.applicantId, restrict_whatsapp_date: this.value })
        this.$utils.emit('show_toast', { text: 'Success' })
      } catch (e) {
        this.$utils.emit('show_toast', { text: 'Failed to update applicant' })
      }
    }
  }
}
</script>
